import React, { useState, useEffect } from "react";
import MasterService from "../../../../Services/masterService";
import EnquiryService from "../../../../Services/EnquiryService";
import { Modal, Col, Row } from "react-bootstrap-v5";
import helperFunction from "../../../../Function/helperFunction";

const DECIMALLENGTH = 3;

const EnquiryPackageModal = (props) => {
  const [packingState, setPackingState] = useState({
    packing: [],
    packaginTypes: [],
    charges: 0,
    freight: 0,
    bookedItems: [],
    freight_charges: [],
  });
  const [itemFreight, setItemFreight] = useState([0, 0, 0]);

  const {
    isShow,
    onHide,
    // SinglePacking,
    // AllPacking,
    originData,
    destinationData,
    volumestate,
    serviceType,
    serviceAmount,
    saveHandle,
    settingSpin,
    getDetail,
    packingJson
  } = props;

  useEffect(() => {
    getPackingList();
    // eslint-disable-next-line
  }, [volumestate]);


  // update package on change of quotation service 
  useEffect(() => {
    getPackingData()
  }, [packingJson])
  const getPackingData = () => {
    if(packingJson.length > 0 && packingState.packing.length > 0){
      let packingstatedata = {...packingState.packing[0],
        packing_type:packingJson[0]?.packing_type,
        packing_charges:packingJson[0]?.packing_charges,
        freight_charges:packingJson[0]?.freight_charges }
        if(packingJson[0].packing_type === "none"){
          setPackingState({...packingState,packing:[packingstatedata],charges: 0,
            freight: 0,
            freight_charges:[0]})
          }else{
          setPackingState({...packingState,packing:[packingstatedata]})
        }
    }
  }
  // update package on change of quotation service 


  const getPackingList = async () => {
    await MasterService.get_package().then((result) => {
      if (result.status === true) {
        let packArray = [{ packing_type: "none" }];
        result.data?.packings.map((item) => {
          return packArray.push({ packing_type: item.packing_type });
        });
        let addOnsPacking = getDetail?.quote_request_items[0]?.add_ons_items
        // console.log("addOnsPacking ....", addOnsPacking)
        let addOnshere = [],
          fcharge = [];

        volumestate?.items?.length &&
        // eslint-disable-next-line
          volumestate.items.map((item, key) => {
            addOnshere.push({
              ...item,
              after_packing_dimension: {
                kilogram: Array.isArray(addOnsPacking) ? addOnsPacking[key]?.kilogram : addOnsPacking?.kilogram,
                length: Array.isArray(addOnsPacking) ? addOnsPacking[key]?.length : addOnsPacking?.length,
                width: Array.isArray(addOnsPacking) ? addOnsPacking[key]?.width : addOnsPacking?.width,
                height: Array.isArray(addOnsPacking) ? addOnsPacking[key]?.height : addOnsPacking?.height,
              },
              packing_type: Array.isArray(addOnsPacking) ? addOnsPacking[key]?.packing_type : addOnsPacking?.packing_type,
              after_packing_total_volume_CBM: Array.isArray(addOnsPacking) ? addOnsPacking[key]?.total_volume_CBM : addOnsPacking?.total_volume_CBM,
              after_packing_total_weight_KG: Array.isArray(addOnsPacking) ? addOnsPacking[key]?.total_weight_KG : addOnsPacking?.total_weight_KG,
              packing_charges: Array.isArray(addOnsPacking) ? addOnsPacking[key]?.packing_charges : addOnsPacking?.packing_charges,
              freight_charges: Array.isArray(addOnsPacking) ? addOnsPacking[key]?.freight_charges : addOnsPacking?.freight_charges,
            });
            fcharge.push(Array.isArray(addOnsPacking) ? addOnsPacking[key]?.freight_charges : addOnsPacking?.freight_charges);
          });
        let finalBalanceAmt,
          ch;

        if (fcharge.length > 0) {
          finalBalanceAmt = fcharge.reduce((a, b) => a + b);
        }

        if (addOnshere.length > 0) {
          ch = addOnshere.reduce(
            (total, item) => Number(item.packing_charges) + total,
            0
          );
        }

        setPackingState({
          ...packingState,
          packaginTypes: packArray,
          bookedItems: addOnshere,
          packing: addOnshere,
          charges: ch || '',
          freight_charges: fcharge,
          freight: finalBalanceAmt || ''
        });
      }
    });
  };

  // console.log("packingState .....", packingState.packing)
  // console.log("volumestate?.items .....", volumestate)

  const packingRadiohandler = (e) => {
    const list = packingState.bookedItems;
    list &&
      list.map((item, index) => {
        packingSelectedhandler(e.target.value, index, "packing_type");

        return (item.packing_type = e.target.value);
      });

    // setPackingState({ ...packingState, bookedItems: list });
  };


  const packingSelectedhandler = (value, index, selType) => {
    let bookedItems = packingState.bookedItems;
    let activePacking = packingState.packing;

    let tempCopy = JSON.parse(JSON.stringify(volumestate.items));
    // let list = packingState.packing;

    // separate actual items data
    let actualItemOriginal = tempCopy.length && tempCopy.map((item) => item);

    if (value !== "none") {
      // list[index] = value; // To show selected packing type

      let itemDimension = {
        length: actualItemOriginal[index].dimension["length"],
        height: actualItemOriginal[index].dimension["height"],
        width: actualItemOriginal[index].dimension["width"],
        weight: actualItemOriginal[index].dimension["kilogram"],
      };

      // setNoneFlag(false)
      let type = helperFunction.toCamelCase(value);
      let actualUnit = helperFunction.calculateItem(itemDimension, type); //

      let dap = helperFunction.dimensionAfterPacking(itemDimension, type); // dms after packing

      let afterUnit = helperFunction.calculateItem(dap, type);

      let diff = (afterUnit - actualUnit).toFixed(DECIMALLENGTH);

      let weight = helperFunction.calculateWeight(
        itemDimension.weight,
        diff,
        type
      );

      let volume = helperFunction.calculateVolume(dap).toFixed(3);

      if (Array.isArray(activePacking)) {
        activePacking[index]["packing_type"] = value;
        setPackingState({
          ...packingState,
          packing: activePacking,
        });
      }

      if (Array.isArray(bookedItems) && Object(dap).length) {
        bookedItems[index]["packing_type"] = value;
        bookedItems[index]["after_packing_dimension"]["length"] = dap.length;
        bookedItems[index]["after_packing_dimension"]["height"] = dap.height;
        bookedItems[index]["after_packing_dimension"]["width"] = dap.width;
        bookedItems[index]["after_packing_dimension"]["kilogram"] =
          Number(weight);
        bookedItems[index]["after_packing_total_volume_CBM"] =
          volume * Number(bookedItems[index]["no_of_pkgs"]);
        bookedItems[index]["after_packing_total_weight_KG"] =
          weight * Number(bookedItems[index]["no_of_pkgs"]);

        bookedItems[index]["total_volume_CBM"] =
          volume * Number(bookedItems[index]["no_of_pkgs"]);
        bookedItems[index]["total_weight_KG"] =
          weight * Number(bookedItems[index]["no_of_pkgs"]);

        let chgs = helperFunction.calculatePrice(
          actualUnit,
          bookedItems[index]["no_of_pkgs"],
          type
        );

        bookedItems[index]["packing_charges"] = Number(
          chgs.toFixed(DECIMALLENGTH)
        );

        bookedItems[index][selType] = value;

        let totalCharges = bookedItems.reduce(
          (total, item) => Number(item.packing_charges) + total,
          0
        );

        packingState.charges = Number(totalCharges);
        setPackingState({
          ...packingState,
          bookedItems: bookedItems,
          // packing: list
        });
      }

      getFreightAmountFun(index);
    } else {
      let actualpacking = packingState.bookedItems;
      // If admin remove packing from item
      actualpacking[index]["after_packing_dimension"]["length"] =
        actualpacking[index].dimension.length;
      actualpacking[index]["after_packing_dimension"]["height"] =
        actualpacking[index].dimension.height;
      actualpacking[index]["after_packing_dimension"]["width"] =
        actualpacking[index].dimension.width;
      actualpacking[index]["after_packing_dimension"]["kilogram"] =
        actualpacking[index].dimension.kilogram;

      actualpacking[index]["after_packing_total_volume_CBM"] = "";

      actualpacking[index]["after_packing_total_weight_KG"] = "";

      let nonearray = packingState.packing;
      nonearray[index].packing_charges = 0;
      nonearray[index].packing_type = "none";
      nonearray[index].freight_charges = 0;
      let nonefreight = itemFreight;
      nonefreight[index] = 0;

      let tf = nonefreight.reduce((a, b) => Number(a) + Number(b));
      let tc = nonearray
        .map((item) => item.packing_charges)
        .reduce((prev, curr) => prev + curr, 0);
      setPackingState({
        ...packingState,
        packing: nonearray,
        freight_charges: nonefreight,
        charges: tc,
        freight: tf,
        bookedItems: actualpacking,
      });
    }
  };

  const getFreightAmountFun = (index) => {
    let tempCopy = JSON.parse(JSON.stringify(volumestate.items));
    // separate actual items data
    let actualItemOriginal = tempCopy.length && tempCopy.map((item) => item);

    let totalPackages =
      packingState.bookedItems &&
      packingState.bookedItems.reduce(
        (total, item) => Number(item.no_of_pkgs) + total,
        0
      );

    let BeforetotalVolume =
      packingState.bookedItems &&
      packingState.bookedItems.reduce(
        (total, item, currIndex) => {
          let tv =
            index === currIndex
              ? Number(item.total_volume_CBM)
              : Number(actualItemOriginal[currIndex].total_volume_CBM);
          return tv + total;
        },
        //Number(item.total_volume_CBM) + total,
        0
      );

    let BeforetotalWeight =
      packingState.bookedItems &&
      packingState.bookedItems.reduce(
        (total, item, currIndex) => {
          let tw =
            index === currIndex
              ? Number(item.total_weight_KG)
              : Number(actualItemOriginal[currIndex].total_weight_KG);
          return tw + total;
        },
        0
      );

    let items =
      packingState.bookedItems &&
      // eslint-disable-next-line
      packingState.bookedItems.map((item, idx) => {
        if (
          packingState &&
          packingState.bookedItems &&
          Array.isArray(packingState.bookedItems)
        ) {
          let after = item.after_packing_dimension,
            before = item.dimension;

          return {
            item_id: item.item_id,
            item_description: item.item_description,
            no_of_pkgs: Number(item.no_of_pkgs),
            dimension: {
              kilogram: after.kilogram
                ? Number(after.kilogram)
                : Number(before.kilogram),
              length: after.length
                ? Number(after.length)
                : Number(before.length),
              width: after.width ? Number(after.width) : Number(before.width),
              height: after.height
                ? Number(after.height)
                : Number(before.height),
            },
            total_volume_CBM: item.after_packing_total_volume_CBM
              ? item.after_packing_total_volume_CBM
              : item.total_volume_CBM,

            total_weight_KG: item.after_packing_total_weight_KG
              ? item.after_packing_total_weight_KG
              : item.total_weight_KG,
            item_token: item.item_token,
          };
        }
      });

    let postData = {
      origin_country: originData?.country,
      origin_country_short_name: originData?.country_short_name,
      origin_city: originData?.city,
      origin_latitude: originData?.latitude,
      origin_longitude: originData?.longitude,
      destination_country: destinationData?.country,
      destination_country_short_name: destinationData?.country_short_name,
      destination_city: destinationData?.city,
      destination_latitude: destinationData?.latitude,
      destination_longitude: destinationData?.longitude,
      number_of_packages: totalPackages,
      volume: Number(BeforetotalVolume.toFixed(3)),
      weight: Number(BeforetotalWeight.toFixed(3)),
      items_goods: volumestate?.items_goods,
      items: items,
      quote_token: volumestate?.quote_token,
    };

    let getFinalQuotezKey;
    if (
      serviceType === "PORTAIR" ||
      serviceType === "PORTSEA" ||
      serviceType === "PORTCOURIER" ||
      serviceType === "PORTLAND"
    ) {
      getFinalQuotezKey = "port_delivery";
    }
    if (
      serviceType === "DOORAIR" ||
      serviceType === "DOORSEA" ||
      serviceType === "DOORCOURIER" ||
      serviceType === "DOORLAND"
    ) {
      getFinalQuotezKey = "door_delivery";
    }
    if (
      serviceType === "CONSOLIDATIONAIR" ||
      serviceType === "CONSOLIDATIONSEA" ||
      serviceType === "CONSOLIDATIONCOURIER"
    ) {
      getFinalQuotezKey = "consolidation_delivery";
    }

    let k = getFinalQuotezKey && getFinalQuotezKey.replace("_delivery", "");
    if (["PORTAIR", "DOORAIR", "CONSOLIDATIONAIR"].includes(serviceType)) {
      settingSpin(true);
      EnquiryService.postCheckAirQuote(postData).then((result) => {
        if (result.status === true) {
          let frtAmt =
            result.all_data.final[getFinalQuotezKey][
            `discount_${k}_grant_total`
            ];
          FinalBookingAmtFun(frtAmt, index);
        } else {
          settingSpin(false);
        }
      });
    } else if (
      ["PORTSEA", "DOORSEA", "CONSOLIDATIONSEA"].includes(serviceType)
    ) {
      settingSpin(true);
      EnquiryService.postCheckSeaQuote(postData).then((result) => {
        if (result.status === true) {
          let frtAmt =
            result.all_data.final[getFinalQuotezKey][
            `discount_${k}_grant_total`
            ];
          FinalBookingAmtFun(frtAmt, index);
        } else {
          settingSpin(false);
        }
      });
    } else if (
      ["PORTCOURIER", "DOORCOURIER", "CONSOLIDATIONCOURIER"].includes(
        serviceType
      )
    ) {
      settingSpin(true);
      EnquiryService.postCheckCourierQuote(postData).then((result) => {
        if (result.status === true) {
          let frtAmt = result.all_data.door_delivery.discount_door_grant_total;
          FinalBookingAmtFun(frtAmt, index);
        } else {
          settingSpin(false);
        }
      });
    } else if (["PORTLAND", "DOORLAND"].includes(serviceType)) {
      settingSpin(true);
      EnquiryService.postCheckLandQuote(postData).then((result) => {
        if (result.status === true) {
          let frtAmt =
            result.all_data.final[getFinalQuotezKey][
            `discount_${k}_grant_total`
            ];
          FinalBookingAmtFun(frtAmt, index);
        } else {
          settingSpin(false);
        }
      });
    }
  };

  const FinalBookingAmtFun = (frtAmt, index) => {
    let balanceAmt = frtAmt - Number(serviceAmount);
    let finalBalanceAmt = 0;
    let itemFreightss = itemFreight;

    itemFreightss[index] = balanceAmt;
    setItemFreight(itemFreightss);
    // set balance amount for perticular item
    finalBalanceAmt = itemFreight.reduce((a, b) => a + b); // get total frieght

    let Freight = packingState.bookedItems;
    Freight[index]["freight_charges"] = itemFreight[index];
    setPackingState({
      ...packingState,
      freight: finalBalanceAmt,
      freight_charges: itemFreight,
      packing: Freight,
    });
    settingSpin(false);
    return true;
  };

  return (
    <Modal show={isShow} size="xl">
      <Modal.Header>
        <Modal.Title>Packing</Modal.Title>
        <span className="ms-auto p-2 cursor-pointer" onClick={onHide}>
          Close
        </span>
      </Modal.Header>
      <Modal.Body className="pb-0">
        <Row>
          <Col md={12}>


            <ul
              class="nav nav-tabs Enquirytablist packagelist"
              id="myTab"
              role="tablist"
            >
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link active"
                  id="individual-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#individual"
                  type="button"
                  role="tab"
                  aria-controls="individual"
                  aria-selected="true"
                // onClick={() => SinglePacking()}
                >
                  <center>
                    <span className="showondesk fw-bold">
                      Different Packing For All
                    </span>
                  </center>
                </button>
              </li>

              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  id="all-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#all"
                  type="button"
                  role="tab"
                  aria-controls="all"
                  aria-selected="true"
                // onClick={() => AllPacking()}
                >
                  <center>
                    <span className="showondesk fw-bold">
                      Same Packing For All
                    </span>
                  </center>
                </button>
              </li>
            </ul>

            <div className="tab-content">
              <div
                className="tab-pane active"
                id="individual"
                role="tabpanel"
                aria-labelledby="individual-tab"
              >

                <table className="table table-bordered text-center volume-calcu">
                  <thead>
                    <tr>
                      <th rowspan="2">S.No.</th>
                      <th rowspan="2">Product Description</th>
                      <th rowspan="2">Pkgs (No.)</th>
                      <th colspan="4">Weight & Dimension per Package</th>
                      <th rowSpan="2">Packing</th>
                      <th rowSpan="2">
                        Packing <br /> Charges <br /> AED
                      </th>
                      <th rowspan="2">
                        Freight <br /> Charges <br /> AED
                      </th>
                    </tr>
                    <tr>
                      <th>Kilogram</th>
                      <th>Length</th>
                      <th>width</th>
                      <th>Height</th>
                    </tr>
                  </thead>

                  <tbody>
                    {packingState.packing &&
                      packingState.packing.map((list, idx) => {
                        return (
                          <tr>
                            <td>{idx + 1}</td>
                            <td>{list.item_description}</td>
                            <td>{list.no_of_pkgs}</td>
                            <td>{list.dimension.kilogram}</td>
                            <td>{list.dimension.length}</td>
                            <td>{list.dimension.width}</td>
                            <td>{list.dimension.height}</td>

                            <td>
                              <select
                                className="form-control"
                                name="packing"
                                onChange={(e) =>
                                  packingSelectedhandler(
                                    e.target.value,
                                    idx,
                                    "packing_type",
                                    {
                                      weight: list.dimension.kilogram,
                                      length: list.dimension.length,
                                      width: list.dimension.width,
                                      height: list.dimension.height,
                                    }
                                  )
                                }
                              >
                                {/* <option value="none">--None--</option> */}
                                {packingState &&
                                  packingState.packaginTypes.length > 0 &&
                                  packingState.packaginTypes.map(
                                    (item, key) => {

                                      if (
                                        item.packing_type === list.packing_type
                                      ) {
                                        return (
                                          <option
                                            selected
                                            disabled
                                            value={item.packing_type}
                                            key={key}
                                          >
                                            {item.packing_type}
                                          </option>
                                        );
                                      } else {
                                        return (
                                          <option
                                            value={item.packing_type}
                                            key={key}
                                          >
                                            {item.packing_type}
                                          </option>
                                        );
                                      }
                                    }
                                  )}
                              </select>
                            </td>

                            <td>{list.packing_charges}</td>
                            <td>
                              {packingState.freight_charges &&
                                packingState.freight_charges[idx]}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>

                <div className="d-flex justify-content-between mb-3">
                  <div className="col-4">
                    <label>Total Packing charges - </label> &nbsp;
                    <span className="fw-bold">
                      {Number(packingState.charges) + Number(packingState.freight)}
                      &nbsp; AED
                    </span>
                    {/* <div>
                      <label>Freight charge - </label> &nbsp;
                      <span className="fw-bold">
                        {packingState.freight}
                        &nbsp; AED
                      </span>
                    </div> */}
                  </div>
                  <div className="col-1">
                    <button
                      type="button"
                      onClick={() => saveHandle(packingState)}
                      className="btn btn-primary ms-auto w-100"
                    >
                      Continue
                    </button>
                  </div>
                </div>
              </div>

              <div
                className="tab-pane"
                id="all"
                role="tabpanel"
                aria-labelledby="all-tab"
              >
                <div className="form-group px-3 pb-3">
                  <h6>Select Packing Type</h6>
                  <div className="form-check form-check-inline d-flex">
                    {packingState &&
                      packingState.packaginTypes.map((item, mykey) => {
                        return (
                          <div key={mykey} className="me-5">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="packing"
                              id={`cartonpacking${mykey}`}
                              value={item.packing_type}
                              onChange={(e) => packingRadiohandler(e)}
                            />
                            <label
                              className="form-check-label"
                              for={`cartonpacking${mykey}`}
                            >
                              {item.packing_type}
                            </label>
                          </div>
                        );
                      })}
                  </div>
                </div>

                <table className="table table-bordered text-center volume-calcu">
                  <thead>
                    <tr>
                      <th rowspan="2">S.No.</th>
                      <th rowspan="2">Product Description</th>
                      <th rowspan="2">Pkgs (No.)</th>
                      <th colspan="4">Weight & Dimension per Package</th>
                      <th rowSpan="2">Packing</th>
                      <th rowSpan="2">
                        Packing <br /> Charges <br /> AED
                      </th>
                      <th rowspan="2">
                        Freight <br /> Charges <br /> AED
                      </th>
                    </tr>
                    <tr>
                      <th>Kilogram</th>
                      <th>Length</th>
                      <th>width</th>
                      <th>Height</th>
                    </tr>
                  </thead>
                  <tbody>
                    {packingState.packing &&
                      packingState.packing.map((item, idx) => {
                        return (
                          <tr>
                            <td>{idx + 1}</td>
                            <td>{item.item_description}</td>
                            <td>{item.no_of_pkgs}</td>
                            <td>{item.dimension.kilogram}</td>
                            <td>{item.dimension.length}</td>
                            <td>{item.dimension.width}</td>
                            <td>{item.dimension.height}</td>
                            <td>{item.packing_type}</td>
                            <td>{item.packing_charges}</td>
                            <td>
                              {packingState.freight_charges &&
                                packingState.freight_charges[idx]}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
                <div className="d-flex justify-content-between mb-3">
                  <div className="col-4">
                    <label>Total Packing charges - </label> &nbsp;
                    <span className="fw-bold">
                      {Number(packingState.charges) + Number(packingState.freight)}
                      &nbsp; AED
                    </span>
                    {/* <div>
                      <label>Freight charge - </label> &nbsp;
                      <span className="fw-bold">
                        {packingState.freight}
                        &nbsp; AED
                      </span>
                    </div> */}
                  </div>
                  <div className="col-1">
                    <button
                      type="button"
                      onClick={() => saveHandle(packingState)}
                      className="btn btn-primary ms-auto w-100"
                    >
                      Continue
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default EnquiryPackageModal;
